<script setup>
import Icon from './Icon.vue'
import { useStore } from 'vuex'
import { computed, onUpdated } from 'vue'

const store = useStore()
const flash = computed(() => store.state.flash)
const clearFlash = () => {
  store.dispatch('flash/clearFlash')
}
onUpdated(() => {
  if(flash.value.type === 'notice') {
    setTimeout(() => {
      clearFlash()
    }, 5000)
  }
})
</script>
<template>
  <div>
    <div v-if="flash.message" :class="`c-flash c-flash--${ flash.type }`">
      <p v-html="flash.message" />
      <span class="close" @click="clearFlash()">
        <Icon name="close" />
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '../../../stylesheets/biz_spa/foundation/_var.scss';

.c-flash {
  position: fixed;
  top: 0;
  width: 100%;
  opacity: 0.9;
  z-index: 9999;
  .close {
    position: absolute;
    top: 18px;
    right: 18px;
    cursor: pointer;
    svg {
      display: block;
      color: $color-base-a;
      fill: $color-base-a;
    }
  }
}
</style>
